import { lazy } from 'react'
import Layout from 'Layout'

import Homepage from 'pages/Homepage'
import Agency from 'pages/Agency'
import Realisations from 'pages/Realisations'
import Realisation from 'pages/Realisation'
// import Articles from 'pages/Articles'
// import Article from 'pages/Article'
import Services from 'pages/Services'
import IntegrationAnimation from 'pages/services/IntegrationAnimation'
import TMASupport from 'pages/services/TMASupport'
import WordPressEcommerce from 'pages/services/WordPressEcommerce'
import ApplicationsWeb from 'pages/services/ApplicationsWeb'
import ProjetsCreatifsIoT from 'pages/services/ProjetsCreatifsIoT'
import Contact from 'pages/Contact'
import Mentions from 'pages/Mentions'
import Sitemap from 'pages/Sitemap'
import Error from 'pages/Error'

const Styleguide = lazy(() => import('pages/Styleguide'))

const routes = [{
    element: <Layout />,
    children: [
        {
            path: `${process.env.PUBLIC_URL}/`,
            element: <Homepage />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/notre-agence`,
            element: <Agency />,
            exact: true
        },
        {
            element: <Realisations />,
            path: `${process.env.PUBLIC_URL}/realisations-sur-mesure`,
            loader: async({ request, params }) => {
                return await fetch(`${process.env.PUBLIC_URL}/realisations/listing.json`, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Cache-Control': 'no-cache' } }).then(res => res.json())
            },
            errorElement: <Error />
        },
        {
            path: `${process.env.PUBLIC_URL}/realisations/:id`,
            loader: async({ request, params }) => {
                const listing = await fetch(`${process.env.PUBLIC_URL}/realisations/listing.json`, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Cache-Control': 'no-cache' } }).then(res => res.json())
                const content = await fetch(`${process.env.PUBLIC_URL}/realisations/${params.id}/content.md`, { headers: { 'Content-Type': 'text/markdown', 'Accept': 'text/markdown', 'Cache-Control': 'no-cache' } }).then(res => res.text())
        
                return { listing, content }
            },
            element: <Realisation />,
            errorElement: <Error />,
            exact: true
        },
        // {
        //     element: <Articles />,
        //     path: `${process.env.PUBLIC_URL}/articles`,
        //     loader: async({ request, params }) => {
        //         return await fetch(`${process.env.PUBLIC_URL}/articles/listing.json`, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Cache-Control': 'no-cache' } }).then(res => res.json())
        //     },
        //     errorElement: <Error />
        // },
        // {
        //     path: `${process.env.PUBLIC_URL}/articles/:id`,
        //     loader: async({ request, params }) => {
        //         const listing = await fetch(`${process.env.PUBLIC_URL}/articles/listing.json`, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Cache-Control': 'no-cache' } }).then(res => res.json())
        //         const content = await fetch(`${process.env.PUBLIC_URL}/articles/${params.id}/content.md`, { headers: { 'Content-Type': 'text/markdown', 'Accept': 'text/markdown', 'Cache-Control': 'no-cache' } }).then(res => res.text())
        
        //         return { listing, content }
        //     },
        //     element: <Article />,
        //     errorElement: <Error />,
        //     exact: true
        // },
        {
            path: `${process.env.PUBLIC_URL}/nos-services`,
            element: <Services />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/services/integration-animation`,
            element: <IntegrationAnimation />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/services/tma-support`,
            element: <TMASupport />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/services/wordpress-ecommerce`,
            element: <WordPressEcommerce />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/services/applications-web`,
            element: <ApplicationsWeb />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/services/projets-creatifs-iot`,
            element: <ProjetsCreatifsIoT />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/nous-contacter`,
            element: <Contact />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/mentions`,
            element: <Mentions />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/plan-du-site`,
            element: <Sitemap />,
            exact: true
        },
        {
            path: `${process.env.PUBLIC_URL}/styleguide`,
            element: <Styleguide />,
            exact: true
        },
        {
            path: '*',
            element: <Error />,
        }
    ]
}
]

export default routes